import { FundraisingPage } from 'store/pages/types';

export interface ISetsState {
  data: ISetsData | null;
  isLoading: boolean;
  error: string | null;
}
export interface ISetsData {
  sets: SetsData[];
}

export interface SetsData {
  set_id: string;
  set_title: string;
  querystring: string;
  start_date: string;
  end_date: string;
  set_desc: string;
  set_title_2: string;
  set_desc_2: string;
  set_title_3: string;
  set_desc_3: string;
  set_type: string;
  is_enabled: boolean;
  display_fundraising_bar: boolean;
  bottom_section: string;
  set_misc: ISetMisc;
  set_pages: FundraisingPage[];
  client_id?: number;
  image_filenames?: {
    header_logo?: string;
    header_video?: string;
    [key: string]: string | undefined;
  };
}

export type ISetMisc = {
  donate_custom_1: string;
  donate_custom_1_helper?: string;
  show_header_button?: boolean;
  goal_alt?: string;
  has_header_video?: boolean;
  has_header_logo?: boolean;
  has_share?: boolean;
  header_bg_color?: string;
  hide_recent_location?: string;
  issue_misc?: IMisc;
  primary_color?: string;
  secondary_color?: string;
  tertiary_color?: string;
  sections?: ISection[];
  share_alt?: string;
  share_disclaimer?: string;
  share_title?: string;
  share_description?: string;
  whitelabeled?: boolean;
};

export type IMisc = {
  card_goal_alt?: string;
  card_helper_text?: string;
  card_raised_alt?: string;
  cta_color?: string;
  edge_color?: string;
};

export const SECTION_LAYOUT = {
  IMAGE_CENTER_BOTTOM: 'IMAGE_CENTER_BOTTOM',
  IMAGE_CENTER_TOP: 'IMAGE_CENTER_TOP',
  IMAGE_LEFT: 'IMAGE_LEFT',
  IMAGE_RIGHT: 'IMAGE_RIGHT',
  NO_IMAGE: 'NO_IMAGE',
} as const;

export type SectionLayout = (typeof SECTION_LAYOUT)[keyof typeof SECTION_LAYOUT];

export type ISection = {
  background_color?: string;
  text_color?: string;
  button_copy?: string;
  cta_button_color?: string;
  description?: string;
  has_image?: boolean;
  id?: string;
  previewSection?: string;
  layout?: SectionLayout | string;
  redirect_link?: string;
  show_button?: boolean;
  title?: string;
};

export type CreateSetBody = {
  set_title?: string;
  set_desc?: string;
  querystring: string;
  set_pages: string[];
  set_type?: string;
  display_fundraising_bar?: boolean;
  set_misc?: any;
  is_enabled?: boolean;
  start_date?: string;
  end_date?: string;
  // 0 is the super-admin "ALL clients" sentinel carried through from the client selector.
  client_id: number;
};

export type UpdateSetBody = CreateSetBody;
